import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../client.js';

/**
 * Retro-Historie (P-21): zeitgestempelte Snapshots aller aktuellen Retro-Items.
 * Die Liste liefert die Snapshots OHNE Items (schlank fuer die Historie-Ansicht);
 * erst der Einzel-Abruf (useRetroSnapshot) laedt den vollstaendigen, read-only
 * Stand inkl. Items.
 */
const KEY = (pid: string) => ['projects', pid, 'retro-snapshots'] as const;
const DETAIL_KEY = (pid: string, snapshotId: string) => ['projects', pid, 'retro-snapshots', snapshotId] as const;

export function useRetroSnapshots(projectId: string | undefined) {
  return useQuery({
    queryKey: KEY(projectId ?? ''),
    queryFn: () => apiClient.get(`/api/v1/projects/${projectId}/retro-snapshots`),
    enabled: !!projectId,
  });
}

export function useRetroSnapshot(projectId: string | undefined, snapshotId: string | undefined) {
  return useQuery({
    queryKey: DETAIL_KEY(projectId ?? '', snapshotId ?? ''),
    queryFn: () => apiClient.get(`/api/v1/projects/${projectId}/retro-snapshots/${snapshotId}`),
    enabled: !!projectId && !!snapshotId,
  });
}

export function useCreateRetroSnapshot(pid: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: Record<string, unknown> = {}) => apiClient.post(`/api/v1/projects/${pid}/retro-snapshots`, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY(pid) }),
  });
}

export function useDeleteRetroSnapshot(pid: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (snapshotId: string) => apiClient.delete(`/api/v1/projects/${pid}/retro-snapshots/${snapshotId}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY(pid) }),
  });
}
